'use client';

import { addCommas } from '@/utils';
import { useCoinThresholds } from '@/features/coin-event/hooks/use-coin-thresholds';

import { useReward } from '@/contexts/reward-context';
import { useSabaCoinEvent } from '@/contexts/saba-coin-context';
import { SabaCoinWithIcon } from '@/components/saba-coin-with-icon';
import { WeeklyInfoContainer } from './weekly-info-container';
import { CoinEventProgressBar } from '../coin-event-progress-bar';
import { ProgressIndicator } from './progress-indicator';
import { RulesAndResetTimeContainer } from './rules-and-reset-time-container';
import { ResetTimeIndicator } from './reset-time-indicator';
import { ArrowRightIcon } from '@/components/svg-icons';

const LevelInfoLegend = () => {
	const { labels } = useReward();
	const handleClick = () => {
		document.dispatchEvent(new CustomEvent('show-saba-coin-reward-level-rule', {
			detail: { openRewardLevelRule: true }
		}));
	}

	return (
		<div className="shop-coin-head__level-desc"
			onClick={handleClick}
		>
			<div className="shop-coin-head__level-text">
				{labels?.lbl_newturnover06}
			</div>
			<ArrowRightIcon />
		</div >
	)
}

export const CoinEventHeader = () => {
	const { currencyName, labels, enableCoinRewardLevel } = useReward();
	const { sabaCoinEventInfo } = useSabaCoinEvent();
	const {
		achievedThreshold,
		totalThresholdAmount
	} = useCoinThresholds();

	return (
		<div className="shop-coin-head">
			<div className="shop-coin-head__label">
				{labels?.lbl_SBCnewoffer}
			</div>
			<div className="shop-coin-head__info">
				<WeeklyInfoContainer title={labels?.lbl_SBCWeeklyBetTotal}>
					<SabaCoinWithIcon coin={sabaCoinEventInfo.WeeklyBettingAmount} />
				</WeeklyInfoContainer>
				<WeeklyInfoContainer title={labels?.lbl_SBCWeeklyRedeemed}>
					<div className="shop-coin-head__text">
						{currencyName} {addCommas(Math.round(sabaCoinEventInfo.WeeklyRedeemedAmount * 1000) / 1000)}
					</div>
				</WeeklyInfoContainer>
			</div>
			<CoinEventProgressBar />
			{ enableCoinRewardLevel && <LevelInfoLegend />}
			
			<div className="shop-coin-head__group">
				<ProgressIndicator
					title={labels?.lbl_SBCAchieved}
					finishedCount={achievedThreshold?.ThresholdId ?? 0}
					totalCount={totalThresholdAmount}
				/>
				<RulesAndResetTimeContainer>
					{sabaCoinEventInfo.WeeklyResetDate ? (
						<ResetTimeIndicator
							description={labels?.lbl_SBCResetInHours}
							resetTime={sabaCoinEventInfo.WeeklyResetDate}
						/>
					) : null}
				</RulesAndResetTimeContainer>
			</div>
		</div >
	);
};